import Big from "big.js"

export const i_families = {
    // 'multifunzione': { 
    //     multifunction: true,
    // },
    'bilancia nawi': {
        id: 'bilancia nawi',
        label: 'bilancia nawi elettronica',
        sw_version_enabled: true,
        enabled: true,
        multifunction: false,
        class: [
            { text: 'N/A', id: 0 },
            { text: 'I', id: 1 },
            { text: 'II', id: 2 },
            { text: 'III', id: 3 },
            { text: 'IIII', id: 4 },
        ],
        uoms: [
            { text: 'milligrammi', id: 'mg' },
            { text: 'grammi', id: 'g' },
            { text: 'kilogrammi', id: 'kg' },
        ],
        shapes: ['quadrata', 'rettangolare', 'triangolare', 'tonda'],
        calibrations: ['interna', 'esterna', 'N/A'],
        tolerance: ["repeatability", "linearity", "eccentricity"],
        report: {
            "leg": { period: "36", check: { 'metro': true, 'platform': ['instrument_class', 'custom_data'] } },
            // "lat": {},
            // "iso": { period: "12", check: { 'metro': true, 'platform': ['custom_data', 'tolerance'] } },
            // "iso_simple": { period: "12", check: { 'metro': true, 'platform': ['custom_data', 'tolerance'] } }
        },
        allowed_primaries: ["pesiera"], //, "bilancia nawi"],
        template: "balance_comparison",
        model: "Balance_Comparison"
    },
    'bilancia nawi meccanica': {
        id: 'bilancia nawi meccanica',
        multifunction: false,
        sw_version_enabled: false,
        label: 'bilancia nawi meccanica',
        enabled: true,
        class: [
            { text: 'N/A', id: 0 },
            { text: 'I', id: 1 },
            { text: 'II', id: 2 },
            { text: 'III', id: 3 },
            { text: 'IIII', id: 4 },
        ],
        uoms: [
            { text: 'milligrammi', id: 'mg' },
            { text: 'grammi', id: 'g' },
            { text: 'kilogrammi', id: 'kg' },
        ],
        shapes: ['quadrata', 'rettangolare', 'triangolare', 'tonda'],
        tolerance: ["repeatability", "linearity", "eccentricity"],
        report: {
            "leg": { period: "36", check: { 'metro': true, 'platform': ['instrument_class', 'custom_data'] } },
            // "lat": {},
            // "iso_simple": { period: "12", check: { 'metro': true, 'platform': ['custom_data', 'tolerance'] } }
        },
        allowed_primaries: ["pesiera"]
    },
    'bilancia awi X': {
        id: 'bilancia awi X',
        label: 'bilancia awi X',
        sw_version_enabled: true,
        enabled: false,
        multifunction: false,
        class: [
            { text: 'N/A', id: 0 },
            { text: 'XI', id: 1 },
            { text: 'XII', id: 2 },
            { text: 'XIII', id: 3 },
            { text: 'XIIII', id: 4 },
        ],
        accuracy: [
            { text: '<1', id: 0 },
            { text: '=1', id: 1 },
            { text: '>1', id: 2 }
        ],
        uoms: [
            { text: 'milligrammi', id: 'mg' },
            { text: 'grammi', id: 'g' },
            { text: 'kilogrammi', id: 'kg' },
        ],
        report: {
            // "leg": { period: "12", check: { 'metro': true, 'platform': ['instrument_class', 'custom_data'] } },
            // "iso_simple": { period: "12", check: { 'metro': true, 'platform': ['custom_data'] } }
        },
        allowed_primaries: ["pesiera", "bilancia nawi"]
    },
    'bilancia awi Y': {
        id: 'bilancia awi Y',
        label: 'bilancia awi Y',
        sw_version_enabled: true,
        enabled: false,
        multifunction: false,
        class: [
            { text: 'N/A', id: 0 },
            { text: 'Y(I)', id: 1 },
            { text: 'Y(II)', id: 2 },
            { text: 'Y(a)', id: 3 },
            { text: 'Y(b)', id: 4 },
        ],
        uoms: [
            { text: 'milligrammi', id: 'mg' },
            { text: 'grammi', id: 'g' },
            { text: 'kilogrammi', id: 'kg' },
        ],
        report: {
            // "leg": { period: "24", check: { 'metro': true, 'platform': ['instrument_class', 'custom_data'] } },
            // "iso_simple": { period: "12", check: { 'metro': true, 'platform': ['custom_data'] } }
        },
        allowed_primaries: ["pesiera", "bilancia nawi"]
    },
    'termometro': {
        id: 'termometro',
        multifunction: false,
        sw_version_enabled: false,
        label: 'termometro',
        enabled: false,
        uoms: [
            { text: 'gradi Celsius', id: '°C' },
            { text: 'gradi Fahrenheit', id: '°F' },
            { text: 'gradi Kelvin', id: '°K' },
        ],
        tolerance: ["thermometer"],
        report: {
            // "iso": { period: "12", check: {} },
        },
        negativeMin: true,
        allowed_primaries: ["fornetto", "termometro campione"]
    },
    'phmetro': {
        id: 'phmetro',
        multifunction: false,
        label: 'phmetro',
        sw_version_enabled: false,
        enabled: false,
        uoms: [
            { text: 'pH', id: 'pH' }
        ],
        tolerance: ["phmeter", "phmeter-termo"],
        report: {
            "iso": { period: "12", check: {} },
        },
        allowed_primaries: ["termometro campione", "multimetro campione"]
    },
    'manometro': {
        id: 'manometro',
        multifunction: false,
        label: 'manometro',
        sw_version_enabled: false,
        enabled: false,
        uoms: [
            { text: 'bar', id: 'bar' },
            { text: 'Pascal', id: 'Pa' }
        ],
        tolerance: ["pressure_gauge"],
        negativeMin: true,
        report: {
            // "iso": { period: "12", check: {} },
        },
        allowed_primaries: ["manometro campione"]
    },
    'dosatore additivi litri': {
        id: 'dosatore additivi litri',
        label:'dosatore additivi litri',
        sw_version_enabled: true,
        enabled: false,
        multifunction: false,
        uoms: [
            { text: 'Litri/dm3', id: 'l' },
            { text: 'Millilitri/cm3', id: 'ml' }
        ],
        tolerance: ["liter_doser"],
        report: {
            // "iso_simple": { period: "12", check: { 'platform': ['tolerance'] } },
        },
        allowed_primaries: ["bilancia nawi"]
    },
    // 'dosatore additivi': {
    //     label: 'dosatore additivi'
    //     multifunction: false,
    //     uoms: [
    //         { text: 'milligrammi', id: 'mg' },
    //         { text: 'grammi', id: 'g' },
    //         { text: 'kilogrammi', id: 'kg' },
    //     ],
    //     tolerance: ["doser"],
    //     report: {
    //         // "iso_simple": { period: "12", check: {} },
    //     },
    //     allowed_primaries: ["bilancia nawi"]
    // },
    'sonda umidità': {
        id: 'sonda umidità',
        label: 'sonda umidità',
        sw_version_enabled: false,
        enabled: false,
        multifunction: false,
        uoms: [
            { text: 'percentuale', id: ' %' }
        ],
        tolerance: ["humidity_probe"],
        report: {
            // "iso_simple": { period: "12", check: { 'platform': ['tolerance'] } }
        },
        allowed_primaries: ['bilancia nawi']
    },
    'gravimetrica': {
        id: 'gravimetrica',
        label: 'gravimetrica',
        sw_version_enabled: false,
        enabled: false,
        multifunction: false,
        class: [
            { text: 'N/A', id: 0 },
            { text: 'I', id: 1 },
            { text: 'II', id: 2 },
            { text: 'III', id: 3 },
            { text: 'IIII', id: 4 },
        ],
        uoms: [
            { text: 'milligrammi', id: 'mg' },
            { text: 'grammi', id: 'g' },
            { text: 'kilogrammi', id: 'kg' },
        ],
        shapes: ['quadrata', 'rettangolare', 'triangolare', 'tonda'],
        calibrations: ['interna', 'esterna', 'N/A'],
        tolerance: ["repeatability", "linearity", "eccentricity"],
        report: {
            // "leg": { period: "36", check: { 'metro': true, 'platform': ['instrument_class', 'custom_data'] } },
            // "lat": {},
            // "iso": { period: "12", check: { 'metro': true, 'platform': ['custom_data', 'tolerance'] } },
            // "iso_simple": { period: "12", check: { 'metro': true, 'platform': ['custom_data', 'tolerance'] } }
        },
        allowed_primaries: [], //["pesiera","bilancia nawi"],
        // template: "balance_comparison",
        // model: "Balance_Comparison"
    },
}

export const p_families = {
    // 'bilancia nawi': {
    // },
    'pesiera': {
        "id": 'pesiera',
        "label": 'Pesiera',
        sw_version_enabled: false,
        "enabled": true,
        "template": "weight_set",
        "model": "WeightSet",
        "uoms": [
            { text: 'grammi', id: 'g' },
            { text: 'kilogrammi', id: 'kg' },
        ],
        "classes": [
            { text: "E1", id: 1 },
            { text: "E2", id: 2 },
            { text: "F1", id: 3 },
            { text: "F2", id: 4 },
            { text: "M1", id: 5 },
            { text: "M2", id: 6 }
        ]
    },
    // 'fornetto': {
    //     "template": "commonPrimary",
    //     "model": "CommonPrimary",
    //     "negativeMin": true,
    //     "uoms": [
    //         { text: 'gradi Celsius', id: '°C' },
    //         { text: 'gradi Fahrenheit', id: '°F' },
    //         { text: 'gradi Kelvin', id: '°K' },
    //     ],
    // },
    // 'manometro campione': {
    //     "template": "pressureGauge",
    //     "model": "PressureGauge",
    //     "negativeMin": true,
    //     "uoms": [
    //         { text: 'bar', id: 'bar' },
    //         { text: 'Pascal', id: 'Pa' }
    //     ]
    // },
    // 'multimetro campione': {
    //     "template": "commonPrimary",
    //     "model": "CommonPrimary",
    //     "negativeMin": true,
    //     "uoms": [
    //         { text: 'milliVolt', id: 'mV' },
    //         { text: 'Volt', id: 'V' }
    //     ]
    // },
    // 'termometro campione': {
    //     "template": "commonPrimary",
    //     "model": "CommonPrimary",
    //     "negativeMin": true,
    //     "uoms": [
    //         { text: 'gradi Celsius', id: '°C' },
    //         { text: 'gradi Fahrenheit', id: '°F' },
    //         { text: 'gradi Kelvin', id: '°K' },
    //     ],
    // }
}
export const leg_families = {
    // 'bilancia awi X': { period: "12" },
    // 'bilancia awi Y': { period: "24" },
    'bilancia nawi': { period: "36" },
    'bilancia nawi meccanica': { period: "36" }
}

export const report_type = {
    'lat': { id: 'lat', name: "Certificazione LAT", prefix: 'LAT', enabled: false},
    'leg': { id: 'leg', name: "Verificazione periodica", prefix: 'LEG', enabled: true },
    'iso': { id: 'iso', name: "Taratura scientifica", prefix: 'ISO', enabled: false},
    'iso_simple': { id: 'iso_simple', name: "Taratura semplificata", prefix: 'SIMP', enabled: false }
}



export const weights_intervals = ["0.001", "10", "10"]

export const linearity_values = ["40", "100", "150", "190"]

export const linearity_values_multirange = ["40", "190"]

export const normalMPE = [1,2,3]

export const division_ranges = {
    "second_limit": "100000",
    "third_limit": "10000",
    "fourth_limit": "1000"
}

export const comparison_values = {
    "first_perc": "0.1",
    "second_perc": "0.5",
    "last_perc": "1"
}

export const repeatability_default = "80"

/*
export const i_uoms = {
    'viscosimetro': [
        { text: 'Poiseuille', id: 'PI' },
        { text: 'CeintiPoise', id: 'CP' }
    ],
    'camera climatica': [
        { text: 'Umidità relativa', id: '%' }
    ],
    'phmetro': [
        { text: 'pH', id: 'pH' }
    ],
    'manometro': [
        { text: 'bar', id: 'bar' },
        { text: 'Pascal', id: 'Pa' }
    ],
    'titolatore': [
        { text: 'Volt', id: 'V' },
        { text: 'Ampere', id: 'A' }
    ]

}
*/

export const block_status_tooltip = {
    'missing': 'prova da fare',
    'failed': 'prova fallita',
    'done': 'prova superata',
    'uncomplete': 'prova incompleta'
}

export const row_status_tooltip = {
    'failed': 'test fallito',
    'done': 'test superato',
    'uncomplete': 'test mancante'
}

export const instrument_status_tooltip = {
    'ready': 'ok',
    'warning': 'strumento in scadenza',
    'alert': 'strumento scaduto',
    'no_reports': 'nessun report'
}

export const report_status_tooltip = {
    'ready': 'report valido',
    'warning': 'report in scadenza',
    'alert': 'report scaduto',
    'failed': 'report fallito'
}

export const operation_status_tooltip = {
    'closed': 'chiuso',
    'working': 'in corso',
    'created': 'nuovo'
}

export const mastercal_welcome = {
    head: "BENVENUTO IN METRYCAL,",
    body_first: "IL PRIMO SISTEMA DI AUTOMAZIONE DI PROCESSI AZIENDALI REALIZZATO PER GESTIRE LA TARATURA DI UNO STRUMENTO (LEGALE, SEMPLIFICATA E ISO) DALLA RICEZIONE DELL'ORDINE FINO AL DEPOSITO DELLA DOCUMENTAZIONE DI LEGGE.",
    body_second: "PER AVERE MAGGIORI INFORMAZIONI SCRIVI A info@gsp-bilance.it",
    uri: "info@gsp-bilance.it"
}

export const mastercal_welcome2 = {
    head: "Questo è MetryCal,",
    body_first:"il management execution system della taratura degli strumenti di misura.",
    body_second:"Per maggiori informazioni scrivi a INFO@GSP-BILANCE.IT oppure chiama il +390119086247",
    uri: "info@gsp-bilance.it"
}
 
export const tolerance = {
    _type: [
        { id: 'manifacturer', text: 'costruttore', 'choice': true },
        { id: 'client', text: 'cliente', 'choice': true },
        { id: 'law', text: 'normativa OIML', 'choice': false }
    ],
    _values: [
        { id: 'unique', text: 'tolleranza unica' },
        { id: 'instrument', text: 'tolleranze standard' }
    ],
    _calc: [
        { id: 'perc', text: '%' },
        { id: 'val', text: 'divisioni' }
    ],
    _instrument_label: {
        'bilancia nawi': {
            "repeatability": "ripetibilità",
            "linearity": "linearità",
            "eccentricity": "eccentricità"
        },
        "termometro": {
            "thermometer": 'linearità'
        },
        "phmetro": {
            "phmeter": "linearità (in mV)",
            "phmeter-termo": "linearità (in °C)"
        },
        "manometro": {
            "pressure_gauge": "linearità"
        },
        "dosatore additivi": {
            "doser": "linearità"
        },
        "dosatore additivi litri": {
            "liter_doser": "linerità"
        },
        "sonda umidità": {
            "humidity_probe": "riproducibilità"
        }
    }
}

/* export const linearity_values_iso = [{
            uom: 'kg',
            max: 300,
            res: '0.05',
            values: [1, 5, 10, 20, 30, 40, 50, 100, 200, 300]
        },
        {
            uom: 'kg',
            max: 15,
            res: '0.0001',
            values: [0.1, 0.5, 1, 2, 3, 4, 5, 6, 10, 15]
        },
        {
            uom: 'g',
            max: 500,
            res: '0.001',
            values: [1, 5, 10, 20, 50, 100, 200, 300, 400, 500]
        },
        {
            uom: 'g',
            max: 2000,
            res: '0.01',
            values: [50, 100, 200, 300, 400, 500, 600, 1000, 1500, 2000]
        },
        {
            uom: 'g',
            max: 6000,
            res: '0.1',
            values: [50, 100, 200, 300, 500, 1000, 2000, 3000, 4000, 6000]
        },

    ] 
    */

/*
export const class_family = [
    { text: 'I', id: 1 },
    { text: 'II', id: 2 },
    { text: 'III', id: 3 },
    { text: 'IIII', id: 4 },
]

export const AWI_family = [
    { text: 'XI', id: 1 },
    { text: 'XII', id: 2 },
    { text: 'XIII', id: 3 },
    { text: 'XIIII', id: 4 },
]
*/
export const stdev_values = {
    in_service: [
        Big(0.6).times(0.01),
        Big(0.3),
        Big(0.3).times(0.01),
        Big(0.6),
        Big(0.2).times(0.01),
        Big(1),
        Big(0.1).times(0.01),
        Big(10),
        Big(0.067).times(0.01)
    ],
    in_installation: [
            Big(0.48).times(0.01),
            Big(0.24),
            Big(0.24).times(0.01),
            Big(0.48),
            Big(0.16).times(0.01),
            Big(0.8),
            Big(0.08).times(0.01),
            Big(8),
            Big(0.053).times(0.01)
        ]
        // in_service: [0.6 * 0.01, 0.3, 0.3 * 0.01, 0.6, 0.2 * 0.01, 1, 0.1 * 0.01, 10, 0.067 * 0.01],
        // in_installation: [0.48 * 0.01, 0.24, 0.24 * 0.01, 0.48, 0.16 * 0.01, 0.8, 0.08 * 0.01, 8, 0.053 * 0.01]
}

export const OIML_CLASSES = {
    divs: [1000, 10000, 100000], // divs = # of divisions to determine classes
    ranges: [0, 50, 200] // points when the OIML changes, 50: 1 d , 200 2d, after 200 3d ( 4th class)
}

/*export const config_default_data = {
    instrument: {
        threshold: {
            type: 'month',
            warning: 2,
            alert: 1
        }
    },
    operation: {
        set_default: true,
        order_nr: 'nr_$date_$user'
    }
}*/

export const tutorial_messages = {
    instr: "Messaggio di default per il tutorial del dispositivo",
    metro: "Messaggio di default per i dati metrologici"
}

export const exempted = ['dosatore additivi litri', 'sonda umidità'] // strumenti che non vengono controllati in fase di scelta primari